import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function About() {
  const [content, setContent] = useState(null);

  useEffect(() => {
    api.get("/content/about").then(({ data }) => setContent(data.value)).catch(() => {});
  }, []);

  return (
    <div data-testid="about-page">
      <section className="pt-24 md:pt-32 pb-16 max-w-7xl mx-auto px-6 md:px-10">
        <div className="overline text-[color:var(--ek-accent)] mb-4">Hakkımızda</div>
        <h1 className="font-display text-5xl md:text-7xl tracking-tight leading-[0.95] max-w-4xl">
          {content?.title || "25 Yıllık Tecrübe. 50.000+ Mezun."}
        </h1>
        <p className="mt-6 text-xl md:text-2xl text-neutral-500 max-w-3xl">
          {content?.subtitle || "Türkiye'nin en köklü sürücü ve iş makineleri kurslarından biri."}
        </p>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-10 py-12 grid grid-cols-2 md:grid-cols-4 gap-4">
        {(content?.stats || []).map((s, i) => (
          <div key={i} data-testid={`stat-${i}`} className="bg-[color:var(--ek-surface-light)] rounded-2xl p-6 md:p-8">
            <div className="font-display text-4xl md:text-5xl tracking-tight text-neutral-900">{s.value}</div>
            <div className="mt-2 text-sm text-neutral-500">{s.label}</div>
          </div>
        ))}
      </section>

      <section className="max-w-4xl mx-auto px-6 md:px-10 py-16 md:py-24">
        <p className="text-lg md:text-xl text-neutral-800 leading-relaxed whitespace-pre-line">
          {content?.body || "Yükleniyor..."}
        </p>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-10 py-16 grid grid-cols-1 md:grid-cols-3 gap-6">
        {[
          { title: "MEB & MYK Akreditasyonu", body: "Tüm sertifikalarımız devlet onaylı ve AB uyumludur." },
          { title: "Uzman Eğitmen Kadrosu", body: "Sektörün en tecrübeli isimleriyle birebir eğitim." },
          { title: "Modern Araç & Makine Filosu", body: "Son teknoloji ekipmanlarla gerçek saha deneyimi." },
        ].map((f, i) => (
          <div key={i} className="p-8 border border-black/5 rounded-2xl">
            <div className="w-10 h-10 rounded-full bg-[color:var(--ek-accent)] mb-6" />
            <h3 className="font-display text-xl mb-3">{f.title}</h3>
            <p className="text-sm text-neutral-600 leading-relaxed">{f.body}</p>
          </div>
        ))}
      </section>
    </div>
  );
}
